import { render, staticRenderFns } from "./icon-choose.vue?vue&type=template&id=6184b69d"
import script from "./icon-choose.vue?vue&type=script&lang=js"
export * from "./icon-choose.vue?vue&type=script&lang=js"
import style0 from "./icon-choose.vue?vue&type=style&index=0&id=6184b69d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports